export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/auth/index.js
// module id = 15
// module chunks = 4